var App = App || {};

App.SharedVideoPlayer = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            selector.each(function () {

                const video = $(this);

                // click to stop all other videos before playing the clicked video
                video.find(".shared-videoPlayer-button").on("click", function () {
                    Play(video);
                });

                // if the video is in a modal, stop it from playing after modal close
                const modal = $(this).parents(".modal");
                if (modal.length > 0) {
                    modal.on("hidden.bs.modal", function () {
                        Stop(video);
                    });
                }

            });
        }

    }

    function Play(video) {

        // stop all other videos before starting a new one
        $(".shared-videoPlayer").each(function () { Stop($(this)); });

        const target = video.find(".shared-videoPlayer-placeholder");
        const button = video.find(".shared-videoPlayer-button");
        const source = button.attr("data-src");
        const title = button.attr("data-title");

        switch (true) {
            case source.toLowerCase().indexOf("youtube") >= 0:
                target.html(Youtube(source, title))
                break;
            case source.toLowerCase().indexOf("youtu.be") >= 0:
                target.html(Youtube(source, title))
                break;
            case source.toLowerCase().indexOf("vimeo") >= 0:
                target.html(Vimeo(source, title));
                break;
            default:
                target.html(Other(source, title));
                break;
        };

        button.hide();
        target.show();
    }

    function Stop(video) {

        const target = video.find(".shared-videoPlayer-placeholder");
        const button = video.find(".shared-videoPlayer-button");

        target.hide().html("");
        button.show();
    }

    function Youtube(source, title) {
        source = AddQueryParameter(source, "autoplay", "1");
        var template = `<iframe src=\"${source}\" title=\"${title}\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>`;
        return template;
    }

    function Vimeo(source, title) {
        source = AddQueryParameter(source, "autoplay", "1");
        var template = `<iframe src=\"${source}\" title=\"${title}\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>`;
        return template;
    }

    function Other(source, title) {
        console.log(source);
        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\"></iframe>";
        return template;
    }
    function AddQueryParameter(url, key, value) {
        const regex = new RegExp(`([?&])${key}=.*?(&|$)`, "i");

        if (regex.test(url)) {
            return url.replace(regex, `$1${key}=${encodeURIComponent(value)}$2`);
        }

        const separator = url.includes("?") ? "&" : "?";
        return `${url}${separator}${key}=${encodeURIComponent(value)}`;
    }

    return {
        Init: Init
    };

})(jQuery);
